import { pipe, values, reduce, get, eq } from 'lodash/fp'

import { ENTITY_TYPES } from 'constants/types'

export const isEntity = pipe(
  values,
  reduce((accumulator, entityType) => {
    accumulator[entityType] = pipe(get('__typename'), eq(entityType))

    return accumulator
  }, {})
)(ENTITY_TYPES)
